import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes.js';

import { changeLang } from '@actions/common/actionCreators';
import { configs } from '@constants/configs/configs';
import { adjustUTCToLocalTime } from '@utils/dates/dateMethods.js';

const NevadaFooter = props => {

    const {
        actions,
        environment: {
            devEnvironment,
            exchangeName,
            links: {
                SIGNUP_AGENCY,
                SIGNUP_AGENT_BROKER,
                SIGNUP_ENROLLMENT_ENTITIES,
                PRIVACY_POLICY
            },
            localDates: {
                timezoneOffsetMs=0,
                dstSavingsMs=0,
                serverDateInUTC,
                timezone,
            },
            user,
            language
        }
    } = props;

    const {
        endpoints
    } = configs;

    const sealSrc = global.__ENV__.PRODUCTION ? '/hix/resources/img/nv_state_seal.png' : '/assets/images/nv_state_seal.png';
    
    const { sDate, sTime } = adjustUTCToLocalTime(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);

    const preventLanguageChange = (url) => {
        if( language != 'en') {
            actions.changeLang(endpoints.CHANGE_LANGUAGE.processReplacements({ language: 'en' })).then(function() {
                window.location.href = url;
            });
        } else {
            window.location.href = url;
        }       
    };

    return(
        <Fragment>
            <footer id="footer--nv" className="usa-footer" role="contentinfo">
                <div className="usa-footer-primary-section gi-footer__container">
                    <div className="usa-grid usa-footer__primary-section gi-footer__primary-section">
                        <a id="footer__logo" href="#" className="seal">
                            <img src = { sealSrc } width="86" alt="State of Nevada"/>
                        </a>
                        <p>
                            <FormattedMessage id='footer.brought_to_you' values={{ exchangeName }}/>
                            <a href='http://exchange.nv.gov/' target='_blank' rel="noopener noreferrer" className='state__exchange' title='Link open in new window or tab'>
                                <FormattedMessage id='footer.link'/>
                            </a>
                        </p>
                        <p> <FormattedMessage id='footer.copyright' values={{ date: (new Date().getFullYear()) }}/>
                            <a href={PRIVACY_POLICY} target='_blank' rel="noopener noreferrer" className='state__privacy-policy' title='Link open in new window or tab'>
                                <FormattedMessage id='footer.privacy_policy' />
                            </a>
                        </p>
                    </div>
                </div>
                {
                    devEnvironment &&
                    <div className="gi-footer__dev-container">
                        <div className="gi-footer__dev-section">
                            <div className="gi-footer__info gi-footer__info-heading">Dev Footer</div>
                            {
                                (user === null || user.role === ALL_USER_ROLES.INDIVIDUAL) &&
                                <Fragment>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_AGENCY) }><FormattedMessage id='footer.agency' /></a>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_AGENT_BROKER) }><FormattedMessage id='footer.agent_broker' /></a>
                                    <a className="gi-footer__link" href='#' onClick={ () => preventLanguageChange(SIGNUP_ENROLLMENT_ENTITIES) }><FormattedMessage id='footer.enrollment_entities' /></a>
                                </Fragment>
                            }
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_date' values={{ date: sDate }}/></div>
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_time' values={{ time: `${sTime} ${timezone}` }}/></div>
                        </div>
                    </div>
                }
            </footer>
        </Fragment>
    );
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeLang
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(NevadaFooter);
